<template>
  <v-form
    ref="form"
    @submit.prevent="save"
  >
    <pr-box :title="titleBox">

      <div slot="buttons-header">
        <v-btn icon @click.native="goToList">
          <v-icon color="white">list</v-icon>
        </v-btn>
      </div>
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-text-field
            v-model="resource.title"
            label="Titulo do Chamado"
            required
            :rules="required"
          />
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field label="Cliente" v-model="clientName" disabled v-if="isVisible" />
        </v-flex>
      </v-layout>

      <v-layout row wrap mb-2>
        <v-flex xs12 md6>
          <v-text-field
            v-model="resource.panel_link"
            label="Link do Painel"
            hint="Caso seja um painel, adicione aqui o link"
            persistent-hint
            :rules="validURL"
          />
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 md12>
          <quill-editor ref="description"
            v-model="resource.description"
            :options="editorOption">
          </quill-editor>
          <small
            v-if="showDescriptionFieldError"
            class="v-messages theme--light error--text"
          >O preenchimento deste campo é obrigatório.</small>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-select
            v-model="project"
            :items="projects"
            no-data-text="Nenhuma registro encontrado"
            clearable
            required
            item-text="name"
            item-value="id"
            label="Selecione um projeto"
            hint="Vincular um projeto a este chamado"
            persistent-hint
            return-object
            :rules="required"
          />
        </v-flex>
        <v-flex xs12 md6>
          <v-select
            :items="cycles"
            v-model="resource.cycle_id"
            item-text="name"
            item-value="id"
            no-data-text="Nenhuma registro encontrado"
            required
            hint="Vincular um ciclo a este chamado"
            label="Selecione um ciclo"
            persistent-hint
            :disabled="!project || cycles.length === 0"
            :rules="required">
            <template slot="selection" slot-scope="data">
              {{ data.item.name }}
            </template>
            <template slot="item" slot-scope="data">
              <template>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ data.item.name }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    <small>{{ data.item.start_date | prDate }} até {{ data.item.end_date | prDate }}</small>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-select>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-select
            :items="priorities"
            v-model="resource.priority_id"
            item-text="description"
            item-value="id"
            required
            hint="Vincular uma prioridade a este chamado"
            label="Selecione a prioridade"
            persistent-hint
            :disabled="priorities.length === 0"
            :rules="required"></v-select>
        </v-flex>
      </v-layout>

      <v-layout row wrap class="mt-4">
        <v-flex xs12 md12>
          <v-card>
            <v-card-title>
              <v-checkbox
                v-model="isMonitor"
                label="Monitorar"
                hide-details
                class="mt-0 pt-0"
              />
              <v-spacer></v-spacer>
              <v-text-field
                v-model="monitor"
                :disabled="!isMonitor"
                label="Email/WhatsApp"
                clearable
                density="compact"
                placeholder="Digite aqui o email ou whatsapp"
                hint="Digite um email ou celular válido. (ex.: meuemail@domain.com ou 71988990101)"
                persistent-hint
              />
              <v-btn
                color="primary"
                dark
                class="mb-2"
                @click.native="addMonitorInList()"
              >ADD</v-btn>
            </v-card-title>
            <v-data-table
              v-if="isMonitor"
              :items="monitors"
              :headers="[
                {
                  text: 'Email/WhatsApp',
                  sortable: false,
                  align: 'left',
                },
                {
                  text: 'Ação',
                  sortable: false,
                  align: 'right',
                },
              ]"
              hide-actions
              no-data-text="Nenhum dado foi adicionado."
              class="elevation-1">
              <template slot="items" slot-scope="props">
                <td>{{ props.item }}</td>
                <td class="text-md-right">
                  <v-btn icon class="mx-0" @click="deleteMonitorInList({ monitor: props.item })">
                    <v-icon color="error">delete</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row wrap class="mt-4">
        <v-flex xs12 md12>
          <v-card>
            <v-card-title>
              Anexos
              <v-spacer></v-spacer>
              <input
                multiple
                ref="files"
                name="file"
                type="file"
                class="input-file"
                @change="handleFileUploads()"/>
              <v-btn slot="activator" color="primary" dark class="mb-2" @click.native="openBrowserAddFile">Anexar Arquivo</v-btn>
            </v-card-title>
            <v-data-table
              :items="fileList"
              :headers="headers"
              hide-actions
              no-data-text="Nenhum arquivo anexado."
              class="elevation-1">
              <template slot="items" slot-scope="props">
                <td>{{ props.item.name }}</td>
                <td>{{ getExtension(props.item.name) }}</td>
                <td>{{ props.item.size | convertToByte }}</td>
                <td class="text-md-right">
                  <v-btn icon class="mx-0" @click="deleteFileInList(props.item)">
                    <v-icon color="error">delete</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row wrap class="mt-4">
        <v-flex xs12 md12>
          <v-autocomplete
            label="Vincular Chamado"
            v-model="linkedSelected"
            :loading="loadingCalled"
            :items="listCalled"
            :filter="customCalledListFilter"
            item-text="title"
            :search-input.sync="searchTerm"
            hide-selected
            return-object
            no-data-text="Nenhuma registro encontrado"
            hint="Informe acima o número do chamado"
            persistent-hint
            @change="onSelectedLinked"
          >
            <template slot="item" slot-scope="props">
              <v-list-tile-content>
                <v-list-tile-title>
                  #{{ props.item.id }} - {{ props.item.title }}
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  Ciclo: {{ props.item.cycle.name }} / Status: {{ cycleStatus[props.item.cycle.active] }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="resource.linked && resource.linked.length > 0" mt-3>
        <v-flex xs12 class="data-called-linked">
          <strong>Chamados Vinculados:</strong>
        </v-flex>
        <v-flex xs12 class="data-called-linked">
          <v-data-table
            :key="`linked_${updatedLinked}`"
            :headers="headersLinked"
            :items="resource.linked"
            :total-items="resource.linked.length"
            :hide-actions="true"
            class="elevation-0">

            <template slot="items" slot-scope="props">
              <td>
                #{{ props.item.id }}
              </td>
              <td>
                {{ props.item.title }}
              </td>
              <td>
                {{ props.item.project.name }}
              </td>
              <td>
                {{ props.item.priority.description }}
              </td>
              <td>
                {{ props.item.cycle.name }}
              </td>
              <td>
                {{ props.item.called_status.description }}
              </td>
              <td class="text-xs-center">
                <v-tooltip top>
                  <template slot="activator">
                    <v-btn color="primary" flat icon @click="removeLink(props.item.id)">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </template>
                  <span>Remover Vínculo</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>

      <div slot="buttons-footer">
        <v-btn flat type="submit" color="primary" :loading="saveLoading">Salvar</v-btn>
      </div>
    </pr-box>
  </v-form>
</template>

<script>
import axios from 'axios';
import CrudMixin from '@/components/mixins/CrudMixin';
import CalledService from '@/features/called/CalledService';
import ProjectService from '@/features/project/ProjectService';
import CycleService from '@/features/cycle/CycleService';
import PriorityService from '@/features/priority/PriorityService';
import UserService from '@/features/user/UserService';

export default {
  name: 'called-form',
  mixins: [CrudMixin],
  data() {
    return {
      isVisible: false,
      isMonitor: false,
      monitor: null,
      monitors: [],
      showDescriptionFieldError: false,
      required: [
        v => !!v || 'O preenchimento deste campo é obrigatório.',
      ],
      validURL: [(value) => {
        if (value && value !== '') {
          const pattern = /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[-a-z\d_]*)?$/i;
          return pattern.test(value) || 'O link informado é inválido';
        }
        return true;
      }],
      headers: [
        {
          text: 'Nome',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Formato',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Tamanho',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Ação',
          sortable: false,
          align: 'right',
        },
      ],
      headersLinked: [
        {
          text: this.$t('attributes.called.number'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.called.title'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.called.project'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.called.priority'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.called.cycle'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.status'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('views.fields.actions'),
          sortable: false,
          align: 'rigth',
        },
      ],
      editorOption: {
        placeholder: 'Descrição do chamado...',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ['link', 'video'],
          ],
        },
      },
      clientName: null,
      fileList: [],
      loading: false,
      projects: [],
      project: null,
      cycles: [],
      cycle: {},
      priorities: [],
      priority: {},
      listCalled: [],
      loadingCalled: false,
      searchTerm: null,
      linkedSelected: null,
      cycleStatus: {
        sim: 'Ativo',
        nao: 'Inativo',
      },
      updatedLinked: 0,
      projectService: new ProjectService(),
      cycleService: new CycleService(),
      priorityService: new PriorityService(),
    };
  },
  watch: {
    project(newValue, oldValue) {
      if (newValue) {
        if (oldValue && newValue.id !== oldValue.id) {
          this.resource.cycle_id = null;
        }
        const params = {
          client_id: this.project.client_id,
          active: 'sim',
        };
        this.cycleService.query(params).then((cycles) => {
          this.cycles = cycles;
        });
      }
    },
    'resource.description': {
      handler(newValue) {
        if (newValue && newValue !== '') {
          this.showDescriptionFieldError = false;
        }
      },
      deep: true,
    },
    async searchTerm() {
      if (this.searchTerm && this.searchTerm !== '') {
        await this.loadCalledListBySearchTerm();
      }
    },
  },
  created() {
    const user = this.$store.state.currentUser;
    if (!UserService.hasProfile(user, ['master', 'admin', 'analista'])) {
      this.clientName = user.client.name;
      this.isVisible = true;
    }
  },
  methods: {
    initCrud() {
      this.serviceType = CalledService;
      this.routerName = 'called';
      this.componentType = 'FORM';

      const requests = [
        this.priorityService.query(),
        this.projectService.query({
          only_project_active: true,
          only_client_active: true,
        }),
      ];
      CalledService.manyRequests(requests)
        .then(axios.spread((priorities, projects) => {
          this.priorities = priorities;
          this.projects = projects;
        }));
    },
    customCalledListFilter(item, queryText) {
      const textOne = item.title.toLowerCase();
      const textTwo = item.description.toLowerCase();
      const textThree = `${item.id}`;
      const searchText = queryText.toLowerCase();
      return textOne.indexOf(searchText) > -1
        || textTwo.indexOf(searchText) > -1
        || textThree.indexOf(searchText) > -1;
    },
    async loadCalledListBySearchTerm() {
      try {
        this.loadingCalled = true;
        const params = { term: this.searchTerm };
        if (this.resource.linked && this.resource.linked.length > 0) {
          params.notIn = this.resource.linked.map(item => item.id);
        }
        this.listCalled = await this.service.query(params);
        this.loadingCalled = false;
      } catch (e) {
        this.$log.error(e);
        this.loadingCalled = false;
      }
    },
    beforeSave() {
      this.stopSaveData = true;
      this.showDescriptionFieldError = !this.resource.description || this.resource.description === '';
      if (this.$refs.form.validate()) {
        this.stopSaveData = false;
        this.reqSaveConfig = { headers: { 'Content-Type': 'multipart/form-data' } };
        const formData = new FormData();
        if (this.resource.title) formData.append('title', this.resource.title);
        if (this.resource.description) formData.append('description', this.resource.description);
        if (this.project && this.project.id) formData.append('project_id', this.project.id);
        if (this.resource.cycle_id) formData.append('cycle_id', this.resource.cycle_id);
        if (this.resource.priority_id) formData.append('priority_id', this.resource.priority_id);

        if (this.resource.linked && this.resource.linked.length) {
          const linked = this.resource.linked.map(item => item.id);
          linked.forEach((item, index) => {
            formData.append(`linked[${index}]`, item);
          });
        }

        if (this.fileList && this.fileList.length) {
          this.fileList.forEach((file, index) => {
            formData.append(`attachments[${index}]`, file);
          });
        }

        if (this.isMonitor && this.monitors.length > 0) {
          formData.append('monitors', this.monitors);
        }

        this.resource = formData;
      }
    },
    afterLoadResource() {
      this.projects.push(this.resource.project);
      this.project = { id: this.resource.project.id, name: this.resource.project.name };
    },
    openBrowserAddFile() {
      this.$refs.files.click();
    },
    handleFileUploads() {
      this.fileList = [...this.fileList, ...this.$refs.files.files];
      this.reset();
    },
    deleteFileInList(file) {
      const index = this.fileList.indexOf(file);
      this.$dialog.confirm({ title: 'Atenção', content: `Deseja remover o arquivo ${file.name}?` })
        .then((response) => {
          if (response.action === 'ok') {
            this.fileList.splice(index, 1);
            this.$toast.success(this.$t('messages.removeSuccess'));
          }
        });
    },
    reset() {
      const input = this.$refs.files;
      input.type = 'text';
      input.type = 'file';
    },
    getExtension(filename) {
      if (filename) {
        const split = filename.split('.');
        return (split[split.length - 1]).toUpperCase();
      }
      return '';
    },
    removeLink(linkedId) {
      const indexOf = this.resource.linked.findIndex(item => item.id === linkedId);
      this.resource.linked.splice(indexOf, 1);
      this.updatedLinked += 1;
    },
    onSelectedLinked(selected) {
      if (!this.resource.linked) {
        this.resource.linked = [selected];
      } else {
        this.resource.linked.push(selected);
      }
      this.listCalled = [];
      this.linkedSelected = null;
    },
    deleteMonitorInList({ monitor }) {
      this.monitors = this.monitors.filter(item => item !== monitor);
    },
    addMonitorInList() {
      if (this.isMonitor && this.monitor && this.monitor !== '') {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phonePattern = /^\d{2}\s?\d{4,5}\d{4}$/;

        if (emailPattern.test(this.monitor) || phonePattern.test(this.monitor)) {
          this.monitors.push(this.monitor);
          this.monitor = null;
        } else {
          this.$toast.error('O email ou número de whatsapp informado é inválido.');
        }
      }
    },
  },
};
</script>
<style>
  .input-file {
    display: none;
  }
  .quill-editor:not(.bubble) .ql-container,
  .quill-editor:not(.bubble) .ql-container .ql-editor {
    height: 15rem !important;
    padding-bottom: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/features/called/CalledForm.vue